import React from 'react';
import LoveButton from '../item/loveButton/loveButton.js'
import FullscreenSocialDownload from './fullscreenSocialDownload.js';
import FullscreenShareButtons from './fullscreenShareButtons.js';
import {utils} from '../../utils'
import {itemActions} from '../../utils'
import {versionManager} from '../../versioning/proGalleryVersionManager.js';
import infoSvg from '-!svg-react-loader!../../assets/images/fullscreen-store/info.svg';
import infoInvertSvg from '-!svg-react-loader!../../assets/images/fullscreen-store/info_invert.svg';

class FullscreenDesktopNavbar extends React.Component {
  constructor(props) {
    super(props);

    this.handleShareArrowNavigation = this.handleShareArrowNavigation.bind(this);
    this.state = {
      shareBoxIsOpened: false,
      focusedShareIcon: 0
    };

    this.isStoreGallery = utils.isStoreGallery();

  }

  handleShareArrowNavigation(e) {

    if (!utils.isAccessibilityEnabled() || !this.state.shareBoxIsOpened) {
      //the keypress events are only effective when the share box was opened via Click or Focus+Enter
      return true;
    }

    switch (e.keyCode || e.charCode) {
      case 38: //up
      case 37: //left
      case 33: //page up
        e.preventDefault();
        e.stopPropagation();
        this.setState({
          focusedShareIcon: Math.max(1, this.state.focusedShareIcon - 1)
        });
        return false;
      case 39: //right
      case 40: //down
      case 34: //page down
        e.preventDefault();
        e.stopPropagation();
        this.setState({
          focusedShareIcon: Math.min(5, this.state.focusedShareIcon + 1)
        });
        return false;
      case 9: //tab
      case 27: //esc
        e.preventDefault();
        e.stopPropagation();
        this.shareBoxButton.focus();
        this.setState({
          focusedShareIcon: 0,
          shareBoxIsOpened: false
        });
        return false;

    }

    return true;
  }

  getLoveButton() {
    return <LoveButton
        key={`fullscreen-love-${this.props.id}`}
        layout="fullscreen"
        device='desktop'
        isSettings={this.props.isSettings}
        {...this.props.love}
        showCounter={true}
      />
  }

  getDownload() {
    return <FullscreenSocialDownload
      key={`fullscreen-download-${this.props.id}`}
      layout="fullscreen"
      device='desktop'
      current={this.props.current}
      styleParams={this.props.styleParams}
      />
  }

  getShareComponent(showDownload, shareIcon) {
    const storeClass = this.isStoreGallery ? 'store' : '';
    const shareBoxOpenedClass = this.state.shareBoxIsOpened ? 'hovered' : '';

    return <div
      key="shareComponent"
      className={`fullscreen-icon fullscreen-social-share-box ${storeClass} ${shareBoxOpenedClass}`}
      onKeyDown={this.handleShareArrowNavigation}
    >
      {shareIcon}
      <FullscreenShareButtons item={this.props.current.item} focus={this.state.focusedShareIcon}/>
    </div>
  }

  getFakeShareComponent(showDownload, shareIcon) {
    const storeClass = this.isStoreGallery ? 'store' : '';

    return <div
      className={`show-tooltip fullscreen-icon fullscreen-social-share-box ${storeClass}`}
      onMouseOver={(e) => itemActions.showTooltip(e, 'Gallery_Sharing_Disabled_In_Editor')}
      onMouseOut={() => itemActions.hideTooltip()}
    >
      {shareIcon}
    </div>

  }

  getShareIcon() {
    return <button className={"fullscreen-social-share-icon progallery-svg-font-icons-share-store"}
               tabIndex={utils.getTabIndex('fullscreenShare')}
               ref={(button) => this.shareBoxButton = button}
               onClick={() => {
                 this.setState({shareBoxIsOpened: !this.state.shareBoxIsOpened})
               }}
               aria-label="Share"
    />;
  }

  getShareButtons() {
    var showDownload = this.props.styleParams.allowDownload && !this.props.current.item.isDemo;
    var shareIcon = this.getShareIcon();

    if (!this.props.styleParams.allowSocial) {
      return false;
    }
    const isLiveSite = utils.isSite() && !this.props.isSettings;

    return isLiveSite ? this.getShareComponent(showDownload, shareIcon) : this.getFakeShareComponent(showDownload, shareIcon);
  }

  getSocialBarContainer() {
    const {styleParams} = this.props;
    const loveButton = (styleParams.loveButton) ? this.getLoveButton() : '';
    const downloadButton = this.getDownload();
    const shareButtons = this.getShareButtons();

    return <div className={"fullscreen-social"}>
      {[
        versionManager.useFullscreenNewDesktopNavbar() ? this.getExpandButton(): '',
        versionManager.useFullscreenNewDesktopNavbar() ? this.getMoreInfoButton() : false,
        versionManager.useFullscreenNewDesktopNavbar() ? downloadButton : loveButton,
        versionManager.useFullscreenNewDesktopNavbar() ? loveButton : downloadButton,
        shareButtons,
      ]}
    </div>;
  }

  getCloseButton() {
    let closeExpandIconClass = 'progallery-svg-font-icons-close-x';
    if (this.props.window.expanded && versionManager.useFullscreenNewDesktopNavbar()) {
      closeExpandIconClass = 'progallery-svg-font-icons-shrink-arrow';
    }

    const closeButton = <button
      className={`fullscreen-icon fullscreen-close ${closeExpandIconClass}`}
      onClick={() => this.props.actions.close()}
      tabIndex={utils.getTabIndex('fullscreenClose')}
      aria-label={`Exit ${this.props.window.expanded ? 'Full Screen' : 'Expand Mode'}`}
      ref={button => this.closeButton = button}
    />

    const fakeCloseButton =  <button
        className="show-tooltip fullscreen-icon fullscreen-close progallery-svg-font-icons-close-x"
        onMouseOver={(e) => itemActions.showTooltip(e, 'This option is not available in editor')}
        onMouseOut={() => itemActions.hideTooltip()} />

    return this.props.isSettings ? fakeCloseButton : closeButton;
  }

  getNavigationArrows() {
    return (
      [
        <button
          className={"fullscreen-icon fullscreen-next progallery-svg-font-icons-arrow_right " + (this.props.current.idx >= (this.props.totalItems - 1) ? ' fullscreen-icon-disabled ' : '')}
          onClick={() => this.props.actions.fadeToNextSlide(1)}
          tabIndex={this.props.current.idx >= (this.props.totalItems - 1) ? -1 : utils.getTabIndex('fullscreenNext')}
          aria-label='Next Item'
        />,
        <button
          className={"fullscreen-icon fullscreen-prev progallery-svg-font-icons-arrow_left " + (this.props.current.idx <= 0 ? ' fullscreen-icon-disabled ' : '')}
          onClick={() => this.props.actions.fadeToNextSlide(-1)}
          tabIndex={this.props.current.idx <= 0 ? -1 : utils.getTabIndex('fullscreenPrev')}
          aria-label='Previous Item'
        />
      ]
    )
  }

  getMoreInfoButton() {
    const {styleParams, current, actions, showInfo} = this.props;
    const shouldHideMoreInfoButton = !styleParams.showInfoExpandButton || this.props.window.expanded || utils.isMobile() || !current.hasInfo;
    if (shouldHideMoreInfoButton) {
      return false;
    }
    const svgInfoWhite = <div className="info-white">{infoSvg()}</div>;//<svg className="info-white" width="18" height="18" viewBox="0 0 18 18"><g fill="none" fill-rule="evenodd"><circle cx="9" cy="9" r="9" fill="none"/><path d="M9.44 3.411a.943.943 0 0 1 .329.328.866.866 0 0 1 0 .892.906.906 0 0 1-.329.328.885.885 0 0 1-.892 0 .872.872 0 0 1-.328-.328.885.885 0 0 1 0-.892.906.906 0 0 1 .776-.45c.16 0 .308.04.444.122zm.387 9.899a.6.6 0 0 0 .335.307c.152.06.36.09.625.09V14a50.765 50.765 0 0 0-1.695-.055c-.274 0-.839.019-1.696.055v-.294c.265 0 .473-.03.626-.089a.6.6 0 0 0 .335-.307c.07-.146.106-.35.106-.609V8.32c0-.433-.079-.747-.236-.943-.157-.196-.434-.294-.83-.294v-.294c.291.027.58.041.868.041.592 0 1.077-.064 1.456-.191V12.7c0 .26.035.463.106.609z"/></g></svg>
    const svgInfoBlack = <div className="info-black">{infoInvertSvg()}</div>;// <svg className="info-black" width="18" height="18" viewBox="0 0 18 18"><g fill="none" fill-rule="evenodd"><circle cx="9" cy="9" r="9" fill="none"/><path d="M9.44 3.411a.943.943 0 0 1 .329.328.866.866 0 0 1 0 .892.906.906 0 0 1-.329.328.885.885 0 0 1-.892 0 .872.872 0 0 1-.328-.328.885.885 0 0 1 0-.892.906.906 0 0 1 .776-.45c.16 0 .308.04.444.122zm.387 9.899a.6.6 0 0 0 .335.307c.152.06.36.09.625.09V14a50.765 50.765 0 0 0-1.695-.055c-.274 0-.839.019-1.696.055v-.294c.265 0 .473-.03.626-.089a.6.6 0 0 0 .335-.307c.07-.146.106-.35.106-.609V8.32c0-.433-.079-.747-.236-.943-.157-.196-.434-.294-.83-.294v-.294c.291.027.58.041.868.041.592 0 1.077-.064 1.456-.191V12.7c0 .26.035.463.106.609z"/></g></svg>


    const showMoreIconClass = versionManager.useFullscreenNewDesktopNavbar() ? '' : `progallery-svg-font-icons-plus`;
    const showLessIconClass = versionManager.useFullscreenNewDesktopNavbar() ? '' : `progallery-svg-font-icons-minus`;

    return <button
        className={"fullscreen-icon fullscreen-info " + (showInfo ? showLessIconClass : showMoreIconClass)}
        onClick={() => actions.toggleInfo()}
        tabIndex={utils.getTabIndex('fullscreenInfo')}
        aria-label={showInfo ? 'Hide Details' : 'Show More Details'}
      >
        {versionManager.useFullscreenNewDesktopNavbar() ? (showInfo ? svgInfoBlack : svgInfoWhite) : false}
      </button>
  }

  getExpandButton() {
    const {isSettings, current, actions} = this.props;
    const shouldHideExpandButton = isSettings || this.props.window.expanded || utils.isMobile() || utils.isiOS() || utils.isEditor() || utils.isPreview();
    const expandIconClass = versionManager.useFullscreenNewDesktopNavbar() ? 'progallery-svg-font-icons-expand-arrow' : 'progallery-svg-font-icons-fullscreen';
    if (isSettings && this.isStoreGallery) {
      return false;
    }

    else if (isSettings) {
      return <button
        className={`show-tooltip fullscreen-icon fullscreen-expand ${expandIconClass}`}
        onMouseOver={(e) => itemActions.showTooltip(e, 'This option is not available in editor')}
        onMouseOut={() => itemActions.hideTooltip()}>
      </button>
    }

    const hiddenStyle = {visibility: 'hidden'};
    return <button
        key={`fullscreen-expand-${this.props.id}`}
        className={`fullscreen-icon fullscreen-expand ${expandIconClass}`}
        style={this.isStoreGallery ? hiddenStyle : {}}
        onClick={() => actions.expandBrowser()}
        tabIndex={utils.getTabIndex('fullscreenExpand')}
        aria-label={this.props.window.expanded ? 'Close full screen' : 'Open in full screen'}
      />
  }

  getNavigationContainer() {
    const controls = [
      versionManager.useFullscreenNewDesktopNavbar() ? false : this.getNavigationArrows(),
      versionManager.useFullscreenNewDesktopNavbar() ? false : this.getMoreInfoButton(),
      (versionManager.useFullscreenNewDesktopNavbar() || this.props.window.expanded) ? false : this.getExpandButton(),
    ]

    return <div className="fullscreen-nav">
        {this.getCloseButton()}
        {this.isStoreGallery ? false : controls}
      </div>
  }

  componentDidMount() {
    if (utils.isAccessibilityEnabled()) {
      if (this.closeButton && this.props.navigatedInto) {
        this.closeButton.focus();
      }
    }
  }

  render() {
    if (utils.isSmallScreen()) {
      return false;
    }

    const shouldHideSocialBar = this.props.window.expanded;

    const socialBarContainer = shouldHideSocialBar ? (versionManager.useFullscreenNewDesktopNavbar() ? false : <div/>) : this.getSocialBarContainer();
    const navigationContainer = this.getNavigationContainer();

    return (
      <div className={`fullscreen-desktop-navbar-container`}>
        {socialBarContainer}
        {navigationContainer}
      </div>
    );
  }
}

export default FullscreenDesktopNavbar;



// WEBPACK FOOTER //
// ./components/fullscreen/fullscreenDesktopNavbar.js